
import thMessages from '../locales/th-TH';

const ThLang = {
    messages: {
        ...thMessages
    },
    locale: 'th-TH',
    
};
export default ThLang;